(() => {
  const acknowledged = {};
  let queued = false;

  const update = (container) => {
    const inputs = [...container.querySelectorAll('[data-viscena-required-ack]')];
    const checkoutId = container.dataset.viscenaCheckoutId;
    const checkout = checkoutId ? document.getElementById(checkoutId) : null;
    const prompt = container.querySelector('[data-viscena-ack-prompt]');

    inputs.forEach((input) => {
      const key = input.dataset.viscenaAckKey;
      if (key && acknowledged[key]) input.checked = true;
      if (key && input.checked) acknowledged[key] = true;
    });

    const ready = inputs.length > 0 && inputs.every((input) => input.checked);
    if (checkout && checkout.disabled === ready) checkout.disabled = !ready;
    if (checkout) checkout.setAttribute('aria-disabled', String(!ready));
    if (prompt && prompt.hidden !== ready) prompt.hidden = ready;
  };

  const initialize = () => {
    document.querySelectorAll('[data-viscena-purchase-acknowledgment]').forEach(update);
  };

  const queueInitialize = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      initialize();
    });
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-viscena-required-ack]');
    if (!input) return;
    const key = input.dataset.viscenaAckKey;
    if (key) acknowledged[key] = input.checked;
    const container = input.closest('[data-viscena-purchase-acknowledgment]');
    if (container) update(container);
  });

  document.addEventListener(
    'submit',
    (event) => {
      if (event.submitter?.name !== 'checkout') return;
      const checkoutId = event.submitter.id;
      const container = document.querySelector(
        `[data-viscena-purchase-acknowledgment][data-viscena-checkout-id="${checkoutId}"]`
      );
      if (!container) return;
      const firstUnchecked = container.querySelector('[data-viscena-required-ack]:not(:checked)');
      if (!firstUnchecked) return;
      event.preventDefault();
      firstUnchecked.focus();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', queueInitialize);
  new MutationObserver(queueInitialize).observe(document.documentElement, { childList: true, subtree: true });
})();
